module.exports = __webpack_public_path__ + "a417335c72129212263f4b563b7686d2.png";